import React, { Component } from "react";
import { connect } from "react-redux";
import { storageAvailable } from "../util";
import ModalConductor from "./ModalConductor";
import { updateCurrentModal, setActivityDetails, getUserData } from "../actions/index";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      askQuesModal: true,
      customQuoteModal: false
    };
  }

  componentDidMount() {
    if (storageAvailable("sessionStorage")) {
      if (sessionStorage.getItem("lmsEnquiryPop")) {
        //LMS Enquiry pop up has been showed to user for this session
      } else {
        const delay = document.getElementById("lms-button").getAttribute("data-delay");

        setTimeout(() => {
          if(this.props.all.currentModal === ""){
            this.props.currentModal("ASK_QUESTION");
          }
        }, parseInt(delay, 10));

        sessionStorage.setItem("lmsEnquiryPop", "opened");
      }
    }
  }

  hideModal = () => {
    this.props.currentModal("");
  };
  render() {
    return (
      <div className="lms-container">
        <ModalConductor {...this.props.all} hideModal={this.hideModal} />{" "}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    all: state
  };
};

const mapDispatchToProps = dispatch => {
  return {
    currentModal: modal => dispatch(updateCurrentModal(modal)),
    setActivityDetails: (id, name) => dispatch(setActivityDetails(id, name)),
    getUserData: id => dispatch(getUserData(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
